import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'accept-policy-to-continue-using-aumico-dialog',
    templateUrl: './accept-policy-to-continue-using-aumico-dialog.component.html',
    styleUrls: ['./accept-policy-to-continue-using-aumico-dialog.component.scss'],
})
export class AcceptPolicyToContinueUsingAumicoDialogComponent {
    @Output() acceptPolicyButtonClicked = new EventEmitter<void>();
    @Output() declinePolicyButtonClicked = new EventEmitter<void>();

    constructor(public dialogRef: MatDialogRef<AcceptPolicyToContinueUsingAumicoDialogComponent>) {}

    public acceptPolicy(): void {
        this.acceptPolicyButtonClicked.emit();
    }

    public declinePolicy(): void {
        this.declinePolicyButtonClicked.emit();
    }
}
